import IApiResponse from "../models/IApiResponse";
import { PptImportFailureResponse, PptImportFailureSubmission } from "../models/IPptImportFailure";
import genericRepositoryService from "./genericRepositoryService";

export type {
  PptImportFailureMetadata,
  PptImportFailureResponse,
  PptImportFailureSubmission,
} from "../models/IPptImportFailure";

const submit = async (submission: PptImportFailureSubmission): Promise<IApiResponse<PptImportFailureResponse>> => {
  const formData = new FormData();
  formData.append("file", submission.file, submission.file.name);
  formData.append("metadata", new Blob([JSON.stringify(submission.metadata)], { type: "application/json" }));

  const response = await genericRepositoryService.submitPptImportFailure(formData);

  if (
    response.isSuccess &&
    (!response.data || typeof response.data.submissionId !== "string" || !response.data.submissionId.trim())
  ) {
    return {
      ...response,
      isSuccess: false,
      errorMessage: "The server did not confirm the diagnostic submission. Please try again.",
    };
  }

  return response;
};

const pptImportFailureService = { submit };

export default pptImportFailureService;
